
// echarts 按需引入

// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts'

// 引入各类型图
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'

// 引入提示框和标题组件
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'

export default echarts



// WEBPACK FOOTER //
// ./src/common/echarts.js